import { jsx } from "react/jsx-runtime";
import useThemePresetClasses from "../../../hooks/useThemePresetClasses.js";
import { cn } from "../../../utils/cn.js";
const List = ({ children, classes, className }) => {
  const { themeClasses } = useThemePresetClasses("List", classes, className);
  return /* @__PURE__ */ jsx("div", { className: cn("flex flex-col", themeClasses == null ? void 0 : themeClasses.root), children });
};
const List$1 = List;
export {
  List$1 as default
};
